export default class Accordion {
	constructor(el) {
		// Store the <details> element
		this.el = el;
		// Store the <summary> element
		this.mutated = false;
		this.summary = el.querySelector('summary');
		// Store the <div class="content"> element
		this.content = el.querySelector('[data-content]');
		this.content.classList.add('transition-all');
		this.content.dataset.height = this.getHeight();
		// preset height for css height animation to work
		if (this.el.open) {
			this.content.style.height = this.content.dataset.height + 'px';
		} else {
			this.content.style.height = '0px';
		}
		// Store if the element is closing
		this.isClosing = false;
		// Store if the element is expanding
		this.isExpanding = false;

		// Detect user clicks on the summary element
		this.summary.addEventListener('click', (e) => this.onClick(e));
	}

	onClick(e) {
		this.el.setAttribute('toggling', true);
		// Stop default behaviour from the browser
		e.preventDefault();
		// Add an overflow on the <details> to avoid content overflowing
		this.content.style.overflow = 'hidden';
		// Check if the element is being closed or is already closed
		if (this.isClosing || !this.el.open) {
			this.open();
			// Check if the element is being openned or is already open
		} else if (this.isExpanding || this.el.open) {
			this.shrink();
		}
	}

	shrink() {
		// Set the element as "being closed"
		this.isClosing = true;

		this.content.style.height = '0px';
		setTimeout(() => {
			this.onAnimationFinish(false);
		}, 300);
	}

	open() {
		// Apply a fixed height on the element
		this.el.open = true;
		this.expand();
	}

	expand() {
		this.isExpanding = true;

		setTimeout(() => {
			this.content.style.height = this.content.dataset.height + 'px';
		}, 10);

		setTimeout(() => {
			this.onAnimationFinish(true);
		}, 300);
	}

	onAnimationFinish(open) {
		// Set the open attribute based on the parameter
		this.el.open = open;
		// Clear the stored animation
		// Reset isClosing & isExpanding
		this.isClosing = false;
		this.isExpanding = false;
		// Remove the overflow hidden and the fixed height
		this.content.style.overflow = '';
		this.el.removeAttribute('toggling');
	}

	// offsetHeight is not reliable (safari) this function is a workaround
	getHeight() {
		const wasOpen = this.el.open;
		if (!wasOpen) {
			this.el.open = true;
		}
		this.content.style.height = 'auto';
		const height = getComputedStyle(this.content).height.slice(0, -2);
		if (!wasOpen) {
			this.el.open = false;
		}
		return height;
	}
}
